import { API_V2 } from "@/config/api";
import { RecurringPlan } from "@/types/models/RecurringPlan";

export const routes = {
  recurringPlansList: `${API_V2}/recurring`,
};

export interface RecurringPlansRequest {
  page: number;
  limit: number;
  sortBy: "createdAt" | "grossAmount";
  sortDirection: "ASC" | "DESC";
}

export interface ExtendedPlan extends RecurringPlan {
  donationCount: number;
}

export interface RecurringPlansResponse {
  result: ExtendedPlan[];
  total: number;
  page: number;
  pages: number;
}
